module.exports = __webpack_public_path__ + "static/media/caret-down.1891b1cb.svg";